import $ from "jquery";

class Accordion {
    run(){
        this.accordion();
    }
    accordion(){

		const accordionItems = document.querySelectorAll('.accordion-item');

		accordionItems.forEach(function (item) {
		    item.addEventListener('click', function () {
		      // Chiudi tutti gli altri elementi del menu
		      accordionItems.forEach(function (accordionItem) {
		        if (accordionItem !== item && accordionItem.classList.contains('active')) {
		          accordionItem.classList.remove('active');
		          const content = accordionItem.querySelector('.accordion-item-content');
		          content.style.display = 'none';
		        }
		      });

		      // Toggle della classe "active" sull'elemento .accordion-item
		      item.classList.toggle('active');

		      // Toggle della visualizzazione del contenuto
		      const content = item.querySelector('.accordion-item-content');
		      content.style.display = (content.style.display === 'block') ? 'none' : 'block';
		    });
		});

    }
}

const accordion = new Accordion();
export default accordion;



